export class NewServiceStats {
    newConnection?: number;
    onboardedCustomers?: number;

    constructor(data?: any) {
        this.newConnection = data?.assigned || 0;
        this.onboardedCustomers = data?.unassigned || 0;
    }
}
